(function() {
	'use strict';

	angular.module('patternLimitation').config(config);

	function config($stateProvider) {
		$stateProvider
				.state(
						'patternLimitation',
						{
							url : '/pattern-limitation',
							views : {
								'patternLimitationView' : {
									templateUrl : 'pattern-limitation/views/pattern-limitation.tpl.html',
									controller : 'PatternLimitationCtrl',
									controllerAs : 'patternLimitation'
								}
							}

						});
	}
}());
